import { render } from "./OrderLogsArea.vue?vue&type=template&id=1d50ce04&ts=true"
import script from "./OrderLogsArea.vue?vue&type=script&lang=ts"
export * from "./OrderLogsArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__